import * as DeveloperPlanIcon from '~/assets/onboarding/developer-plan-icon.svg';
import * as ProPlanIcon from '~/assets/onboarding/pro-plan-icon.svg';
import * as StarterPlanIcon from '~/assets/onboarding/starter-plan-icon.svg';
import { PRO_PLAN as PRO_PLAN_CODE } from '~/constants/plans';

import {
  OnboardingPlan,
  OnboardingRoute,
  OnboardingStepName,
  type Plan,
} from '../types/onboarding.type';

export const NEW_ONBOARDING_CUTOFF_DATE = new Date('2026-09-10T19:00:00Z');

export const ONBOARDING_ROUTES = {
  [OnboardingStepName.addOrders]: OnboardingRoute.connectStore,
  [OnboardingStepName.plan]: OnboardingRoute.plan,
  [OnboardingStepName.senderAddress]: OnboardingRoute.senderAddress,
};

export const STARTER_PLAN: Plan = {
  description: 'join:onboarding.plans.starter.description',
  features: [
    'join:onboarding.plans.starter.features.line1',
    'join:onboarding.plans.starter.features.line2',
    'join:onboarding.plans.starter.features.line3',
    'join:onboarding.plans.starter.features.line4',
    'join:onboarding.plans.starter.features.line5',
  ],
  icon: StarterPlanIcon,
  id: OnboardingPlan.STARTER,
  planCode: 'PAYG 30 Label Limit',
  pricing: 'join:onboarding.plans.starter.pricing',
  title: 'join:onboarding.plans.starter.title',
};

export const PRO_PLAN: Plan = {
  description: 'join:onboarding.plans.pro.description',
  featureCaption: 'join:onboarding.plans.pro.featureCaption',
  features: [
    'join:onboarding.plans.pro.features.line1',
    'join:onboarding.plans.pro.features.line2',
    'join:onboarding.plans.pro.features.line3',
    'join:onboarding.plans.pro.features.line4',
    'join:onboarding.plans.pro.features.line5',
  ],
  icon: ProPlanIcon,
  id: OnboardingPlan.PRO,
  planCode: PRO_PLAN_CODE,
  pricing: 'join:onboarding.plans.pro.pricing',
  title: 'join:onboarding.plans.pro.title',
};
export const API_PLAN: Plan = {
  description: 'join:onboarding.plans.api.description',
  features: [
    'join:onboarding.plans.api.features.line1',
    'join:onboarding.plans.api.features.line2',
    'join:onboarding.plans.api.features.line3',
    'join:onboarding.plans.api.features.line4',
  ],
  icon: DeveloperPlanIcon,
  id: OnboardingPlan.API,
  planCode: 'API',
  pricing: 'join:onboarding.plans.api.pricing',
  title: 'join:onboarding.plans.api.title',
};

export const PLANS: Plan[] = [STARTER_PLAN, PRO_PLAN, API_PLAN];
export { PRO_PLAN as DEFAULT_PLAN };
